/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Megaphone = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 63 50">
    <path
      d="M50 28.125V21.875H62.5V28.125H50ZM53.75 50L43.75 42.5L47.5 37.5L57.5 45L53.75 50ZM47.5 12.5L43.75 7.5L53.75 0L57.5 5L47.5 12.5ZM9.375 46.875V34.375H6.25C4.53125 34.375 3.0599 33.763 1.83594 32.5391C0.611979 31.3151 0 29.8438 0 28.125V21.875C0 20.1562 0.611979 18.6849 1.83594 17.4609C3.0599 16.237 4.53125 15.625 6.25 15.625H18.75L34.375 6.25V43.75L18.75 34.375H15.625V46.875H9.375ZM28.125 32.6562V17.3438L20.4688 21.875H6.25V28.125H20.4688L28.125 32.6562ZM37.5 35.4688V14.5312C38.9062 15.7812 40.0391 17.3047 40.8984 19.1016C41.7578 20.8984 42.1875 22.8646 42.1875 25C42.1875 27.1354 41.7578 29.1016 40.8984 30.8984C40.0391 32.6953 38.9062 34.2188 37.5 35.4688Z"
      fill="#DAD6FF"
    />
  </BaseSvgIcon>
)

export default Megaphone
